module.exports = ".notifier {\n  height: 0;\n  overflow: hidden;\n}\n\n\nhtml .page-wrapper .page-content {\n  padding: 0px !important;\n}\n\n"